import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const UserDashboardPostAListingPageLoadable = clientOnlyLazy({
  loader: () => import('./UserDashboardPostAListingPage.dynamic'),
  loading: LoadableLoadingSection,
});
